import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseURL } from '../services/api';
import { StrQueryI } from '../interfaces/filters';
import { constURL } from '../services/enum.services';
import {
  appealsFromAppApiI,
  operatorPatchI,
  phoneResponsePatchI,
  priorityPatchI,
  responseFromServerI,
  responsePatchI,
  statusPatchI,
  draftPatchI,
  AppealHistoryPropsI,
} from '../interfaces/appealsAPI';


export const AppealsFromAppAPI = createApi({
  reducerPath: 'appealsFromAppAPI',
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  tagTypes: ['Appeals', 'fileList'],
  endpoints: (build) => ({
    fetchAllAppealsFromApp: build.query<appealsFromAppApiI, StrQueryI>({
      query: ({
        page,
        searchQuery,
        typeSearch,
        questionStatus,
        firstDate,
        lastDate,
        priority,
        activeOperator,
        term,
        source,
        role,
        filterOperator,
        quesTheme,
      }: StrQueryI) => {
        if (role === '4') {
          return `${constURL.APPEALS_APP}?page=${page}&priority=${priority}&operatorSub=${activeOperator}&questionStatus=${questionStatus}&quesTheme=${quesTheme}&firstDate=${firstDate}&lastDate=${lastDate}&typeSearch=${typeSearch}&searchQuery=${searchQuery}&term=${term}&source=${source}`
        } else {
          if (filterOperator !== null && filterOperator !== '0') {
            return `${constURL.APPEALS_APP}?page=${page}&priority=${priority}&operatorSub=${filterOperator}&questionStatus=${questionStatus}&quesTheme=${quesTheme}&firstDate=${firstDate}&lastDate=${lastDate}&typeSearch=${typeSearch}&searchQuery=${searchQuery}&term=${term}&source=${source}`
          } else {
            return `${constURL.APPEALS_APP}?page=${page}&priority=${priority}&operator=${activeOperator}&questionStatus=${questionStatus}&quesTheme=${quesTheme}&firstDate=${firstDate}&lastDate=${lastDate}&typeSearch=${typeSearch}&searchQuery=${searchQuery}&term=${term}&source=${source}`
          }
        }
      },
      providesTags: ['Appeals'],
    }),
    changeOperator: build.mutation<operatorPatchI, operatorPatchI>({
      query: (data) => ({
        url: constURL.CHANGE_APPEAL_APP,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Appeals'],
    }),
    changeStatus: build.mutation<statusPatchI, statusPatchI>({     
      query: (data) => ({
        url: constURL.CHANGE_APPEAL_APP,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Appeals'],
    }),
    changePriority: build.mutation<priorityPatchI, priorityPatchI>({
      query: (data) => ({
        url: constURL.CHANGE_APPEAL_APP,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Appeals'],
    }),
    changeResponse: build.mutation<responseFromServerI, responsePatchI>({    // отправка ответа на обращение
      query: (data) => ({
        url: constURL.CHANGE_APPEAL_APP,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Appeals'],
    }),
    changeDraft: build.mutation<responseFromServerI, draftPatchI>({      // отправка черновика на сервер
      query: (data) => ({
        url: constURL.CHANGE_APPEAL_APP,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Appeals'],
    }),
    changePhoneResponse: build.mutation<phoneResponsePatchI, phoneResponsePatchI>({
      query: (data) => ({
        url: constURL.CHANGE_APPEAL_APP,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Appeals'],
    }),
    getAppealHistory: build.query<AppealHistoryPropsI[], string>({
      query: (appealId) => ({
        url: `${constURL.APPEALS_HISTORY}?appealId=${appealId}`,
        method: 'GET',
      }),
      transformResponse: (response: { quantityToPages: number; data: AppealHistoryPropsI[] }) => response.data,
      providesTags: ['Appeals'],
    }),
  }),
});


export const {
  useFetchAllAppealsFromAppQuery,
  useChangeOperatorMutation,
  useChangeStatusMutation,
  useChangePriorityMutation,
  useChangePhoneResponseMutation,
  useChangeResponseMutation,
  useChangeDraftMutation,
  useGetAppealHistoryQuery, 
} = AppealsFromAppAPI;